module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/patient-information.json
// module id = 375
// module chunks = 46424679908722